import { render } from "./AllOrder.vue?vue&type=template&id=0d475bbc&scoped=true"
import script from "./AllOrder.vue?vue&type=script&lang=js"
export * from "./AllOrder.vue?vue&type=script&lang=js"

import "./AllOrder.vue?vue&type=style&index=0&id=0d475bbc&scoped=true&lang=less"

import exportComponent from "/home/huiwen/TeamCity/buildAgent/work/78c9eac71a3ca1e9/webs/pdam-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d475bbc"]])

export default __exports__